<div class="entity-list sbs-grid-layout sbs-two-column-grid sbs-three-column-grid sbs-margin-top sbs-padding-bottom ">
  <div *ngFor="let org of sortedEntities; let i = index" class="entity sbs-even-rows sbs-content-container sbs-border-blue sbs-cursor-pointer" [ngClass]="{'disabled-border':this.org.disabled }" id="entity-list" (click)="goTo(org._id)">
    <div *ngIf="showDate" class="date">
      {{org.lastModificationAt | date: dateFormat}}
    </div>
    <div *ngIf="color==='science-organisation' && !org.type" class="logo-science-organization">
      <img src="{{org.logoUrl ? org.logoUrl : ''}}"/>
      <mat-icon>{{org.icon}}</mat-icon>
    </div>

    <div *ngIf="org.type" class="logo-self-report">
      <img [src]="this.selfReportService.getIconFromSelfReportType(org.type)">
    </div>
    <div *ngIf="icon" ngClass="{{'sbs-'+color}}">
      <mat-icon>{{icon}}</mat-icon>
    </div>
    <div class="sbs-flex-layout science-organization-info">
      <span class="sbs-body-title entity-list-title" ngClass="{{'sbs-'+color}}">
        {{org.title ? org.title : getTranslatedLabelFromTitleAndDescription(org.titleAndDescriptions, "title")}}
      </span>
      <p class="description" *ngIf="org.description || getTranslatedLabelFromTitleAndDescription(org.titleAndDescriptions, 'description').length> 0">
        {{org.description ? org.description : getTranslatedLabelFromTitleAndDescription(org.titleAndDescriptions, "description")}}
      </p>
    </div>
    <div class="sbs-even-rows sbs-center-columns next-navigation">
      <span class="navigation-arrow" [ngClass]="{'rtl': this.direction==='rtl'}" [dir]="this.direction==='rtl' ? 'rtl': 'ltr'"></span>
    </div>
  </div>
</div>


